import React, { useState,useEffect } from "react";
import Confirm from "../../Helper/Loaders/Confirm";
import Loader from "../../Helper/Loaders/Loader";
import { OutlinedButton } from "../../Components/CustomButton";
import {  useDispatch } from "react-redux";

import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  Box,
} from "@mui/material";
import {sendPostRequestFeature } from "../../Api/Api";
import { SetSessionExpired } from "../../Actions";

function RequestFeatureDialog(props) {
  const dispatch = useDispatch();

  const val = "";
  const [feature, setFeature] = useState("");
  const [description, setDescription] = useState("");
  const [helperTextFeature, setHelperTextFeature] = useState(false);
  const [helperTextDescription, setHelperTextDescription] = useState(false);
  const [loader, setLoader] = useState(false);
  const [confirmation, setConfirmation] = useState(false);

  useEffect(()=>{
    const timer = setTimeout(() => {
      confirmation && props.handleCloseRequestFeatureDialog();
    }, 5000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
},[confirmation])

  return (
    <div>
      <Dialog
        onClose={props.handleCloseRequestFeatureDialog}
        aria-labelledby="customized-dialog-title"
        open={props.openRequestFeatureDialog}
        anchorEl={props.anchorElRequestFeatureDialog}
        container={props.anchorElRequestFeatureDialog.parentNode}
      >
        <div style={{ padding: "16px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 0px",
            }}
          >
            <Typography variant="paperHeader">{!confirmation && <>Request Feature</>}</Typography>
            <IconButton
              onClick={props.handleCloseRequestFeatureDialog}
              fontSize="small"
            >
              <CloseIcon style={{ fontSize: "18px" }} />
            </IconButton>
          </div>

          <div>
            <Typography style={{ width: "500px" }}></Typography>
          </div>

         

          {!loader && !confirmation ? (
            <div id="main_body">
               <div
            style={{
              padding: "0px 0px",
            }}
          >
            {helperTextFeature ? (
              <TextField
                error={true}
                helperText="Must not be empty"
                variant="standard"
                fullWidth
                inputProps={{ style: { fontSize: 13 } }}
                onChange={(event) => {
                  setFeature(event.target.value);
                  setHelperTextFeature(false);
                }}
                margin="normal"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="textSubtitleSmall">
                        Feature name:
                      </Typography>
                    </InputAdornment>
                  ),
                }}
              />
            ) : (
              <TextField
                name="cls"
                required
                inputProps={{ style: { fontSize: 13 } }}
                variant="standard"
                fullWidth
                onChange={(event) => {
                  setFeature(event.target.value);
                }}
                margin="normal"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="textSubtitleSmall">
                        Feature name:
                      </Typography>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </div>
              <div
                style={{
                  padding: "8px 0px",
                }}
              >
                <div
                  style={{
                    display: "inline",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  {helperTextDescription ? (
                    <TextField
                      error={true}
                      helperText="Please add description for the feature"
                      id="outlined-multiline-static"
                      multiline
                      onChange={(event) => {
                        setDescription(event.target.value);
                        setHelperTextDescription(false);
                      }}
                      fullWidth
                      rows={8}
                      inputProps={{ style: { fontSize: 13 } }}
                      placeholder="Add description of the feature"
                      defaultValue={val}
                    />
                  ) : (
                    <TextField
                      id="outlined-multiline-static"
                      multiline
                      onChange={(event) => {
                        setDescription(event.target.value);
                      }}
                      fullWidth
                      rows={8}
                      inputProps={{ style: { fontSize: 13 } }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                      placeholder="Add description of the feature"
                      defaultValue={val}
                    />
                  )}
                </div>
              </div>
              <br></br>
              <Box sx={{display:"flex",justifyContent:"center"}}>
              <OutlinedButton
                variant="contained"
                onClick={() => {
                  if (feature.length === 0) {
                    setHelperTextFeature(true);
                  } else if (description.length === 0) {
                    setHelperTextDescription(true);
                  } else {
                    setLoader(true);
                    sendPostRequestFeature(feature,description).then((res)=>{
                      if(res.responseStatus.code === 200)
                      {
                        setConfirmation(true);
                        setLoader(false);
                      }
                      else
                      {
                        if(res.responseStatus.code === -2)
                        dispatch(SetSessionExpired(true))
                        
                      }
                    })
                  }
                }}
              >
                <Typography variant="textSubtitleWhite">Submit</Typography>
              </OutlinedButton>
              </Box>
            </div>
          ) : (
            <div style={{ height: "227px",width: "500px" }}>
              {loader && <Loader />}
              {confirmation && <Confirm text={"Feature request submitted sucessfully"}/>}
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
}

export default RequestFeatureDialog;
